<video #videoElement id="idMultiVideojs"
 class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" autoplay  style="background-image:url('assets/images/poster.jpg');background-size: 100%;">
 <!-- style="height: 100%;" -->
  <source type="rtmp/mp4" src="null">
</video>